export default class CertificationsTabs {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        $( document ).ready(function() {
            $('.accordion-tab').on('click', function (e){
                e.preventDefault();
                let parent = $(this).parent();
                parent.hasClass('active') ? parent.removeClass('active') : parent.addClass('active');
            })

            $('.tab-item').hide();
            $('.tab-item').first().show().css('opacity', '1');

            $('.cert-tab').on('click', function(e) {
                e.preventDefault();
                $('.cert-tab').removeClass('active');
                $(this).addClass('active');

                let tabIndex = $(this).data('index');

                $('.tab-item').hide();
                $('.tab-item').eq(tabIndex).fadeIn().css('opacity', '1');
            });
        })
    }

}